// components/EventStatusBanner/EventStatusBanner.jsx

import { STATUS_CONFIG } from "./eventStatus.config";

/* eslint-disable react/prop-types */
function EventStatusBanner({ status }) {
  const config = STATUS_CONFIG[status];

  if (!config) return null;

  return (
    <div
      role="alert"
      className={`w-full rounded-lg my-10 p-4 text-center border border-white/10 ${config.backgroundClass}`}
    >
      <h3 className={`text-lg font-semibold ${config.textClass}`}>
        {config.title}
      </h3>
      <p className="mt-1 text-sm text-zinc-300">
        {config.description}
      </p>
    </div>
  );
}

export default EventStatusBanner;
